import { createSelector } from 'reselect';
import { RootState } from '../root.reducer';
import { WebLauncherLandingState } from 'types';

const selectCache = (state: RootState) => state.webLauncherLandingCache;

export const selectWebLaunchRequest = createSelector(
  selectCache,
  (cache: WebLauncherLandingState) => cache.webLaunchRequest
);

export const selectWebLaunchRequestError = createSelector(
  selectCache,
  (cache: WebLauncherLandingState) => cache.webLaunchRequestError
);
